export enum Status {
  InProgress = 'analyzing', // In progress build
  Analyzed = 'analyzed', // Steady state
  Failed = 'failed', // Error
  Unknown = 'unknown', // Unresolved or unsupported
}
